import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Cookies from 'js-cookie';
import { DEFAULT_PLAN_ID, SUBSCRIPTION_PLANS, COUNTRY_CODE_COOKIE } from '../../constants';
import { getCurrencyByCountryCode } from '../../locales';
import styled from 'styled-components';

const Interval = styled.span`
  color: var(--c-manatee);
`;

class Price extends React.Component {
  state = { currency: null };

  componentDidMount() {
    const currency = getCurrencyByCountryCode(Cookies.get(COUNTRY_CODE_COOKIE));
    if (currency && currency !== this.props.currency) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ currency });
    }
  }

  render() {
    const { currency, price, interval } = this.props;
    const effectiveCurrency = this.state.currency || currency;

    return (
      <React.Fragment>
        <FormattedNumber currency={effectiveCurrency} style="currency" value={price} />
        {interval && (
          <Interval>
            {interval === 'monthly' ? (
              <FormattedMessage id="index.plans-section.monthly-billed" defaultMessage="/month" />
            ) : (
              <FormattedMessage id="index.plans-section.yearly-billed" defaultMessage="/year" />
            )}
          </Interval>
        )}
      </React.Fragment>
    );
  }
}

Price.defaultProps = {
  currency: 'EUR',
  price: SUBSCRIPTION_PLANS[DEFAULT_PLAN_ID].monthlyPrice,
};

Price.propTypes = {
  price: PropTypes.number,
  currency: PropTypes.string.isRequired,
  interval: PropTypes.string,
};

export default withRouteData(Price);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/common/Price.js